@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@import '@helsenorge/designsystem-react/scss/breakpoints';

.pageheader {
  margin-bottom: spacers.getSpacer(m);

  @media screen and (min-width: map.get($grid-breakpoints, md)) {
    margin-bottom: spacers.getSpacer(l);
  }

  &__sharinginfo {
    margin-top: spacers.getSpacer(s);
  }

  &__title {
    overflow-wrap: break-word;
    display: inline;

    &--trigger {
      padding-right: 2.5rem;

      @media screen and (min-width: map.get($grid-breakpoints, md)) {
        padding-right: 3rem;
      }
    }
  }

  &__hjelpetrigger {
    display: inline-block;
    position: relative;

    // margin-left må matche bredden på HelpTriggerIcon
    margin-left: -2rem;
    bottom: -0.15rem;

    @media screen and (min-width: map.get($grid-breakpoints, md)) {
      bottom: -0.2rem;
    }
  }

  &__subtitle {
    font-size: 1.375rem;
    font-weight: 600;
    line-height: spacers.getSpacer(l);

    @media screen and (min-width: map.get($grid-breakpoints, lg)) {
      font-size: spacers.getSpacer(m);
    }
  }

  &__ingress {
    margin-top: spacers.getSpacer(xs);
    margin-bottom: 0;

    @media screen and (min-width: map.get($grid-breakpoints, md)) {
      margin-top: spacers.getSpacer(s);
    }
  }

  &__sharing-status {
    margin-top: spacers.getSpacer(m);
  }

  &__favoritter {
    display: inline-block;
    position: relative;
    vertical-align: middle;

    @media screen and (min-width: map.get($grid-breakpoints, md)) {
      padding-bottom: 0.4rem;
    }
  }
}
